module.exports = __webpack_public_path__ + "img/6.833126f8.webp";